import http from '@/http'
const URL = '/admin/journeys'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (id, payload) => {
  if (id) {
    return http.put(URL + `/${id}`, payload)
  }
  return http.post(URL, payload)
}

export const create = (payload) => http.post(URL, payload)

// --- Compositor de jornadas por IA ---
export const aiStart = () => http.post(`${URL}/ai/start`)
export const aiTurn = (sessionId, message) => http.post(`${URL}/ai/turn`, { session_id: sessionId, message })
export const aiShow = (id) => http.get(`${URL}/ai/${id}`)
export const update = (id, payload) => http.put(URL + `/${id}`, payload)
export const remove = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (id, payload) => http.put(URL + `/${id}/status`, payload)
export const duplicate = (id) => http.post(URL + `/${id}/duplicate`)
export const exportJourney = (id) => http.get(URL + `/${id}/export`)
export const importJourney = (payload) => http.post(URL + `/import`, payload)

// Analytics
export const getMetrics = (id) => http.get(URL + `/${id}/analytics/metrics`)
export const getFunnel = (id) => http.get(URL + `/${id}/analytics/funnel`)
export const getEntries = (id, params) => http.get(URL + `/${id}/analytics/entries`, { params })
export const getNodeStats = (id) => http.get(URL + `/${id}/analytics/nodes`)
export const getLogs = (id, params) => http.get(URL + `/${id}/analytics/logs`, { params })
export const getEnrollmentTimeline = (journeyId, enrollmentId) => http.get(URL + `/${journeyId}/analytics/enrollment/${enrollmentId}/timeline`)

// Reference data helpers
export const getEmailTemplates = async () => http.get('/admin/settings/email')
export const getWaTemplates = async () => http.get('/admin/settings/wa/templates')
export const getStatuses = async () => http.get('/admin/settings/status-select')
export const getGroups = async () => http.get('/admin/settings/groups')
export const getTags = async () => http.get('/admin/tags')
export const getForms = async (params) => http.get('/admin/forms', { params })
export const getJourneysList = async () => http.get(URL, { params: { limit: 100 } })
export const getFieldTypes = async () => http.get('/admin/field-types/grouped')
export const getRefStatuses = async () => http.get('/admin/settings/refstatus')
export const getConditionFields = async (params = {}) => http.get('/admin/journeys/condition-fields', { params })
export const getFollowUpRules = async () => http.get('/admin/follow-up-rules', { params: { is_active: 1, limit: 100 } })

export default {
  list,
  show,
  save,
  create,
  update,
  remove,
  changeStatus,
  duplicate,
  exportJourney,
  importJourney,
  getMetrics,
  getFunnel,
  getEntries,
  getNodeStats,
  getLogs,
  getEnrollmentTimeline,
  getEmailTemplates,
  getWaTemplates,
  getStatuses,
  getGroups,
  getTags,
  getForms,
  getJourneysList,
  getFieldTypes,
  getRefStatuses,
  getConditionFields,
  getFollowUpRules,
  aiStart,
  aiTurn,
  aiShow
}
